import * as React from 'react';

import * as Styled from './pop-up-window.styles';
import type { PopUpWindowPrimitiveProps } from './pop-up-window.types';

export const PopUpWindowPrimitive = React.forwardRef<
  HTMLDivElement,
  PopUpWindowPrimitiveProps
>(
  (
    { children, closeButtonProps, noPadding, hide, ...props },
    forwardedRef
  ): JSX.Element => (
    <Styled.PopUpWindow
      $noPadding={noPadding}
      data-xds="PopUpWindow"
      ref={forwardedRef}
      {...props}
    >
      {hide && (
        <Styled.CloseButton
          data-dismiss="modal"
          onClick={hide}
          size="large"
          {...closeButtonProps}
        />
      )}
      {children}
    </Styled.PopUpWindow>
  )
);

PopUpWindowPrimitive.displayName = 'PopUpWindow (Primitive)';
